import styled, { css } from "styled-components";

import Messages from "core/Messages";

import { convertPxToRem } from "frontend/components/helpers";
import {
    mobileHeaderHeight,
    desktopHeaderHeight
} from "core/SiteHeader/constants";
import breakpoints from "core/breakpoints";

export const GeneralFormErrorMessage = styled(Messages).attrs({
    styleType: "solid",
    infoType: "error",
    width: "auto"
})`
    position: fixed;
    z-index: 100000;
    right: ${convertPxToRem({ px: 40 })};
    top: ${convertPxToRem({ px: 40 })};

    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        ${({ withHeader }) =>
            withHeader &&
            css`
                right: ${convertPxToRem({ px: 24 })};
                top: ${convertPxToRem({ px: mobileHeaderHeight + 24 })};
            `}
    }

    @media (min-width: ${breakpoints.tablet.rem}) {
        ${({ withHeader }) =>
            withHeader &&
            css`
                right: ${convertPxToRem({ px: 24 })};
                top: ${convertPxToRem({
                    px: desktopHeaderHeight + 24
                })};
            `}
    }
`;
